const surveyTitles = {
  1: "Type d'entreprise",
  2: "Entreprise d'économie sociale",
  3: "Caractéristiques de l'entreprise",
  4: "Dirigeant d'entreprise",
  5: "Connectivité et infrastructure",
  6: "Gestion des données",
  7: "Sécurité informatique",
  8: "Impacts de la digitalisation",
  9: "Stratégie numérique",
  10: "Collaboration et travail à distance",
  11: "Numérique responsable et économie circulaire",
  12: "Logiciels et applications informatiques",
  13: "Cloud computing",
  14: "Technologies avancées",
  15: "Industrie 4.0",
  16: "Intelligence artificielle",
  17: "Administration en ligne",
  18: "E-facturation",
  19: "Politique commerciale digitale",
  20: "E-Business",
  21: "Interopérabilité Numérique",
  22: "Validation"
};

export default surveyTitles;